import { TableRow } from './input/table-row';
import { TableEventTargetType } from '../enum/table-event-target-type';
import { ObjToUpdate } from './ObjToUpdate';
import { TableTh } from './input/table-th';
import { TableTd } from './input/table-td';

export class TableOutputEvent {
    row: TableRow;
    cell: TableTh | TableTd;
    target: any;
    type: 'CLICK' | 'MOUSEENTER';
    targetType: TableEventTargetType;
    targetHtml: any;
    objListToUpdate: ObjToUpdate[];

    public isDataRowTarget(): boolean {
        return (this.targetType === TableEventTargetType.DATA_ROW) ? true : false;
    }

    public isHeaderTarget(): boolean {
        return (this.targetType === TableEventTargetType.HEADER) ? true : false;
    }
}
